import { useState, useCallback } from "react";
import {
  getOrders,
  getOrder,
  updateOrder,
  deleteOrder,
} from "../API/endpoint";

export const useOrders = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const loadOrders = useCallback(async () => {
    try {
      setLoading(true);
      const data = await getOrders();
      setOrders(data);
      setError("");
    } catch (err) {
      setError("Erreur lors du chargement des commandes");
      console.error(err);
    } finally {
      setLoading(false);
    }
  }, []);

  const loadOrderDetails = useCallback(async (orderId) => {
    try {
      setLoading(true);
      const data = await getOrder(orderId);
      setError("");
      return data;
    } catch (err) {
      setError("Erreur lors du chargement des détails de la commande");
      console.error(err);
      return null;
    } finally {
      setLoading(false);
    }
  }, []);

  const handleUpdateOrderStatus = useCallback(async (orderId, status) => {
    try {
      await updateOrder(orderId, { status });
      await loadOrders();
      setError("");
      return true;
    } catch (err) {
      setError("Erreur lors de la mise à jour de la commande");
      console.error(err);
      return false;
    }
  }, [loadOrders]);

  const handleUpdateOrderAddress = useCallback(async (orderId, addressData) => {
    try {
      await updateOrder(orderId, addressData);
      await loadOrders();
      setError("");
      return true;
    } catch (err) {
      setError("Erreur lors de la mise à jour de l'adresse");
      console.error(err);
      return false;
    }
  }, [loadOrders]);

  const handleDeleteOrder = useCallback(async (orderId) => {
    if (window.confirm("Êtes-vous sûr de vouloir supprimer cette commande ? Cette action est irréversible.")) {
      try {
        await deleteOrder(orderId);
        await loadOrders();
        setError("");
        return true;
      } catch (err) {
        setError("Erreur lors de la suppression de la commande");
        console.error(err);
        return false;
      }
    }
    return false;
  }, [loadOrders]);

  const pendingOrdersCount = orders.filter(order => order.status === "En attente").length;

  return {
    orders,
    loading,
    error,
    setError,
    loadOrders,
    loadOrderDetails,
    handleUpdateOrderStatus,
    handleUpdateOrderAddress,
    handleDeleteOrder,
    pendingOrdersCount,
  };
};
